import { render, staticRenderFns } from "./ChatImageLightbox.vue?vue&type=template&id=0c74d14e&"
import script from "./ChatImageLightbox.vue?vue&type=script&lang=js&"
export * from "./ChatImageLightbox.vue?vue&type=script&lang=js&"
import style0 from "./ChatImageLightbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports